import { Environment } from 'src/environments/environment.interface';
import { DEV_CONFIG } from './okta.config';

export const environment: Environment = {
  production: false,
  hmr: false,
  apiUrl: '/api/',
  wsUrl: 'ws://api-sync.local.wmg.com:4200/ws',
  okta: {
    ...DEV_CONFIG,
    redirectUri: 'http://localhost:4200/implicit/callback',
  },
  featureFlags: {
    gls_2110_show_feature_flag_widget: true,
    gls_2464_license_tab: true,
    gls_2490_invoice_tab: true,
    gls_3392_licence_info_panel: true,
    gls_2602_grid_view: true,
    gls_2514_activity: true,
    gls_3096_playlist_panel_edit_and_view_grouptags: true,
    gls_2931_licenses_tab_for_request: false,
    gls_2932_invoices_tab_for_request: true,
    gls_2931_grid_columns: false,
    gls_4025_multitab: true,
    enable_msr_payment_delete: true,
  },
};
